export const XERO_INTEGRATION_ROUTE = 'integration';
export const XERO_SETTINGS_ROUTE = 'settings';
export const XERO_INTEGRATION_SETUP_ROUTE = 'integration-setup';
